import RingLoader from 'react-spinners/RingLoader';

export const Loading = () => {
  return (
    <div className={'w-100 h-100 d-flex justify-content-center align-items-center'}>
      <RingLoader size={60} color={'#971B4D'} loading={true} speedMultiplier={2} />
    </div>
  );
};
